var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card v-center"},[_c('CollectionIcon'),_vm._v(" "+_vm._s(_vm.$t('wallet.collections'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }